export default __webpack_public_path__ + "static/media/goldBadge.0493ecea.svg";